import type { RefundInvoice } from '~/api/graphql/generated/types'

import { RefundDialogProvider } from './context/RefundDialogProvider'
import { RefundDialogV2 } from './RefundDialogV2'

export interface RefundDialogContainerV2Props {
  isOpen: boolean
  onClose: () => void
  refundInvoice: RefundInvoice
}

export const RefundDialogContainerV2 = ({
  isOpen,
  onClose,
  refundInvoice,
}: RefundDialogContainerV2Props) => (
  <RefundDialogProvider refundInvoice={refundInvoice}>
    <RefundDialogV2 isOpen={isOpen} onClose={onClose} />
  </RefundDialogProvider>
)
